import { FireFilled, RocketFilled } from '@ant-design/icons'
import { Tabs } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { FeaturedPosts, TrendingPost } from './trending.component'
import s from './trending.module.less'

const { TabPane } = Tabs

export const TrendingContainer = () => {
  const { t } = useTranslation()
  const [tab, setTab] = React.useState<string>('featuredPost')

  const subheader = (
    <div className={s.subheader}>
      <Tabs
        animated={false}
        activeKey={tab}
        size={'small'}
        type={'card'}
        tabBarGutter={14}
        onChange={(tab) => setTab(tab)}
      >
        <TabPane
          tab={
            <span className={s.title}>
              <RocketFilled style={{ color: '#FF9F1C', marginRight: 4 }} />
              {t('trend.featured')}
            </span>
          }
          key='featuredPost'
        />
        <TabPane
          tab={
            <span>
              <FireFilled style={{ color: '#F04242', marginRight: 4 }} />
              {t('trend.post')}
            </span>
          }
          key='trendPost'
        />
      </Tabs>
    </div>
  )

  const content = {
    trendPost: <TrendingPost />,
    featuredPost: <FeaturedPosts />,
  }[tab]

  return (
    <>
      {subheader}
      {content}
    </>
  )
}
